// extracted by mini-css-extract-plugin
module.exports = {"kidsAccountNavWrapper":"AR","hidden":"AS","menuBackground":"AT","avatar":"AU","header":"AV","accountNavAvatar":"AW","buttonPlaceholder":"AX","accountLinks":"AY","accountLink":"AZ"};